<template lang="pug">
  footer.main-footer
    small {{ $t('copyright') }}
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';
  footer {
    padding: 2em;

    text-align: center;
    color: $dark-gray;
    font-weight: 600;
  }
</style>
